// /**
//  * # slider.js
//  * - サービス概要セクションで表示される、横スクロール型のスライダーのロジックを記述
//  * - アニメーションライブラリ「GSAP」を使用
//  */

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// GSAPの初期化
gsap.registerPlugin(ScrollTrigger);

const isSP = window.innerWidth < 1024;

const sliderElement = document.getElementById('slider');

// アニメーションの設定
gsap.to(sliderElement, {
  x: () => -sliderElement.clientWidth,
  ease: 'none',
  duration: 10,
  left: isSP ? '30%' : '0',
  scrollTrigger: {
    trigger: '.p-three-measures__bottom-inner',
    start: 'center center',
    scrub: 2,
    pin: 'main'
  }
});
